export default __webpack_public_path__ + "static/media/yelp.6dbf1cd0.svg";